
/**************************************************************************************************/
/*   File: /src/app/shared/models/territorial.area.regulations.ts                         */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Monday April 1st 2019                                                          */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Apr 19 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { LocalDocument } from './local.document';
/**
 * The territorial area regulations
 */
export class TerritorialAreaRegulations {
    /**
     * The delta doc id
     */
    deltaDoc: LocalDocument;
    /**
     * The final doc id
     */
    finalDoc: LocalDocument;
    /**
     * The original doc
     */
    originalDoc: LocalDocument;
    /**
     * The territorial area code
     */
    territorialAreaCode: string;

}